import { createFileRoute } from '@tanstack/react-router'

import { EstimatesPage } from '@/components/estimates/estimates-page'

export const Route = createFileRoute('/_authenticated/_layout/mes-devis')({
  component: EstimatesPage,
  staticData: {
    hero: { subtitle: 'Suivez vos demandes et répondez à nos propositions', title: 'Mes devis' },
  },
})
